export class BlockLabel {
    blockLabelId: number;
    institucionId: string;
    code: string;
    name: string;
    status: boolean;
    capacity: number;
    tipoAccion?: number;
}